import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";

import ModalCarrito from "./ModalCarrito.js";
import Modal from "./Modal.js";

class Clientes extends Component {
  constructor() {
    super();
    this.state = {
      columns: [
        {
          Header: "id",
          id: "id",
          accessor: "id",
          show: false,
          private: true,
        },
        {
          Header: "Codigo",
          accessor: "Codigo",
          style:{textAlign:"center"},
          id: "Codigo",
        },
        {
          Header: "Nombre / Razón Social",
          id: "Nombre",
          accessor: "Nombre",
        },
        {
          Header: "Documento",
          id:"Documento",
          accessor:"Documento",
          style:{textAlign:"center"},
        },
        {
          Header: "Email",
          id:"Email",
          accessor:"Email",
        },
      ]
    };
  }

  render() {
    const { data, pages, loading } = this.state;
    const { modernTheme } = this.props;
    return (
      <ParadigmaTable
        modernTheme={modernTheme}
        buttons={[
          {
            edit: true,
            component: (props) => <Modal {...props} action="CREATE" />,
            permission:"ecommerce_ventas_clientes_new",
          },
          {
            edit: true,
            component: (props) => <Modal {...props} action="EDIT" />,
            permission:"ecommerce_ventas_clientes_edit",
          },
          {
            detail: true,
            component: (props) => <Modal {...props} action="DETAIL" />,
            permission:"ecommerce_ventas_clientes_detail",
          },
          {
            edit: true,
            component: (props) => <Modal {...props} action="DELETE" />,
            permission:"ecommerce_ventas_clientes_delete",
          },
          {
            edit: true,
            component: (props) => <ModalCarrito {...props} action="EDIT" />,
            permission:"ecommerce_ventas_clientes_edit",
          }
        ]}
        apiUrl={api.gestion.ventas.clientes}
        columns={this.state.columns}
        title={"Clientes"}
      />
    );
  }
}

export default Clientes;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Clientes/Clientes.js